export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_FILES(state, documents) {
    state.files = documents;
  },
};
